import { render, staticRenderFns } from "./StandmansRatingList.vue?vue&type=template&id=74e7fa91&scoped=true&"
import script from "./StandmansRatingList.vue?vue&type=script&lang=ts&"
export * from "./StandmansRatingList.vue?vue&type=script&lang=ts&"
import style0 from "./StandmansRatingList.vue?vue&type=style&index=0&id=74e7fa91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e7fa91",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VProgressCircular,VTab,VTabItem,VTabs,VTabsItems})
